package layout

enum class OffsetPattern {
    HALF,
    THIRD,
    RANDOM,
}
